import type { Href } from 'expo-router';
import type { JoinIntent } from '@/stores/useJoinIntentStore';
import { getJoinKindConfiguration } from './joinKind';

export type AccountGateState = 'complete' | 'error' | 'incomplete' | 'loading';

type PrivateAccountGateRedirectInput = {
  accountGateState: AccountGateState;
  joinCompletionPending: boolean;
  joinIntent: JoinIntent | null;
  joinResumePending: boolean;
  pathname: string;
};

const welcomeHandoffRoutes = new Set(['/welcome/join', '/welcome/profile']);
const joinRoutes = new Set<string>([
  getJoinKindConfiguration('organization').joinPathname,
  getJoinKindConfiguration('team').joinPathname,
]);

export function isWelcomeJoinHandoffRoute(pathname: string) {
  return welcomeHandoffRoutes.has(pathname);
}

export function getPrivateAccountGateRedirect({
  accountGateState,
  joinCompletionPending,
  joinIntent,
  joinResumePending,
  pathname,
}: PrivateAccountGateRedirectInput): Href | null {
  const isJoinRoute = joinRoutes.has(pathname);
  const isWelcomeHandoff = isWelcomeJoinHandoffRoute(pathname);

  if (accountGateState === 'incomplete') {
    if (joinIntent && joinResumePending && !isWelcomeHandoff) {
      return '/welcome/join';
    }

    return isJoinRoute ? '/welcome' : null;
  }

  if (
    accountGateState !== 'complete' ||
    joinCompletionPending ||
    !joinIntent ||
    isJoinRoute ||
    isWelcomeHandoff
  ) {
    return null;
  }

  return {
    pathname: getJoinKindConfiguration(joinIntent.kind).joinPathname,
    params: {
      code: joinIntent.code,
      ...(joinIntent.memberType ? { memberType: joinIntent.memberType } : {}),
    },
  };
}
